import "./Footer.css"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <Link to="/" className="logo">
            <div className="footer-logo-icon">
              <span>⚡</span>
            </div>
            <span className="footer-logo-text">NetzSync</span>
          </Link>
      </div>
      
      <div className="footer-center">
        <p className="footer-copyright">Web Designs by VT Netzwelt Pvt Ltd, all rights reserved</p>
        <p className="footer-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet</p>
      </div>

      <div className="footer-right">
        <div className="contact-info">
          <h3>CONTACT INFO:</h3>
          <p>Office:</p>
          <p>123-456-7890</p>
          <p>XXX, XX street</p>
          <p>XXXXXX, XX 58501</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer
